import JsonArrayMapper from "../helpers/JsonArrayMapper";
import WarehousePrices from "./WarehousePrices";
export default class WarehousePricesCollection extends JsonArrayMapper {
  constructor(data) {
    super(data, WarehousePrices);
  }
}